import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Col,
  Row,
  Input,
  Button,
  Card,
  Container,
  Badge,
  InputGroup,
  InputGroupText,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Triangle } from "react-loader-spinner";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import OrderServices from "../../../services/OrderingServices/OrderServices";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import OrderDetailModal from "../component/OrderDetailModal";
import PublicOrderingServices from "../../PublicOrdering/services/PublicOrderingServices";
import toast from "react-hot-toast";
import StatusBadge from "../../../Components/Common/Badge";
import ConfirmPayment from "../../POS/page/OrderSummary/component/ConfirmPayment";
import InvoiceBillModal from "../../POS/page/OrderSummary/component/InvoiceBillModal";

const OrderDetail = () => {
  const { id } = useParams();
  const customerInfoStr = localStorage.getItem("CustomerInfo");
  const customerInfo = customerInfoStr ? JSON.parse(customerInfoStr) : null;

  const token = customerInfo?.accessToken || null;

  const [orderDetail, setOrderDetail] = useState(null);
  console.log("🚀 ~ OrderDetail ~ orderDetail:", orderDetail);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const printRef = useRef(null);
  const [selectedData, setSelectedData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(false);

  // Payment modal states
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  console.log("🚀 ~ OrderDetail ~ selectedPayments:", selectedPayments)
  const [paymentAmounts, setPaymentAmounts] = useState({});
  console.log("🚀 ~ OrderDetail ~ paymentAmounts:", paymentAmounts)
  const [promoCode, setPromoCode] = useState("");
  const [discountPercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [promoSuccess, setPromoSuccess] = useState(false);
  const [promoError, setPromoError] = useState(null);
  const [creditData, setCreditData] = useState(null);

  const toggleStatusModal = () => setStatusModalOpen(!statusModalOpen);
  const toggleModal = () => setModalOpen(!modalOpen);
  const togglePaymentModal = () => setPaymentModalOpen(!paymentModalOpen);

  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const orgInfo = user?.organizationInfo || {};

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const orderStatusEnum = [
    { name: "Cancelled", value: 3 },
    { name: "Ongoing", value: 1 },
    { name: "Preparing", value: 4 },
    { name: "Completed", value: 2 },
  ];

  const fetchOrderDetail = async () => {
    try {
      const response = await OrderServices.getOrderDetail(id);
      setOrderDetail(response);
      if (response?.payments?.length > 0) {
        response.payments = response.payments.map((payment) => {
          const tx = new Date(payment.transactionDate);
          return {
            ...payment,
            date: tx.toLocaleDateString(),
            time: tx.toLocaleTimeString(),
          };
        });
      }
    } catch (error) {
      console.log("🚀 ~ fetchOrderDetail error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetail();
  }, [id]);

  // Transform order data for ConfirmPayment component
  const transformOrderDataForPayment = () => {
    if (!orderDetail) return {};

    return {
      [orderDetail.id || "takeaway"]: {
        orderId: orderDetail.id,
        items: orderDetail.orderDetails || [],
      },
    };
  };

  // Calculate totals for payment
  const calculateTotals = {
    subTotal: orderDetail?.totalAmount || 0,
    total: orderDetail?.grandTotal || 0,
    tax: orderDetail?.taxAmount || 0,
    discount: orderDetail?.discountAmount || 0,
  };

  // Handle checkout/payment completion
const handleCheckout = async () => {
  if (!orderDetail?.id) return toast.error("Invalid order ID");
  if (!selectedPayments || selectedPayments.length === 0)
    return toast.error("Please select at least one payment method");

  setLoading(true);

  try {
    // Determine primary payment
    let primaryPayment = selectedPayments[0]; // Take first one as primary
    let primaryAmount = Number(paymentAmounts[primaryPayment.id]) || 0;

    // Prepare other payments
    const otherPaymentsPayload = selectedPayments
      .slice(1) // all except first
      .map(p => ({
        paymentTypeId: Number(p.id),
        amount: Number(paymentAmounts[p.id]) || 0
      }));

    const payload = {
      orderId: Number(orderDetail.id),
      tableId: orderDetail.tableId || null,
      paymentTypeId: Number(primaryPayment.id),
      amount: primaryAmount,
      panNumber: "",
      remarks: "",
      multiplePayments: otherPaymentsPayload.length > 0 ? otherPaymentsPayload : null,
      ...(discountAmount ? { discountAmount: Number(discountAmount) } : {}),
      ...(discountPercent ? { discountPercentage: Number(discountPercent) } : {}),
      ...(creditData?.amount ? { creditLogs: creditData } : {}),
    };

    console.log("Final payload:", JSON.stringify(payload, null, 2));

    await OrderServices.markOrderPaid(payload);

    toast.success("Payment processed successfully!");
    togglePaymentModal();
    fetchOrderDetail();
    setSelectedPayments([]);
    setPaymentAmounts({});
    setCreditData(null);
    setDiscountAmount("");
    setDiscountPercent("");
  } catch (error) {
    console.error("Payment failed:", error);
    toast.error("Payment processing failed");
  } finally {
    setLoading(false);
  }
};

  // Directly open payment modal for 'Completed' without status modal
  const handleDirectPayment = () => {
    // Ensure you set the status modal off
    if (!paymentModalOpen) {
      setPaymentModalOpen(true);
    }
  };

  // Handle status update - trigger payment modal for "Completed"
  const updateOrderStatus = async (status) => {
    // If status is "Completed" (value: 2), open payment modal instead
    if (status === 2) {
      toggleStatusModal();
      togglePaymentModal();
      return;
    }

    try {
      setUpdatingStatus(true);

      await PublicOrderingServices.updateOrderStatus({
        token,
        orderRefNumber: orderDetail?.orderRefrenceId,
        status,
      });

      toast.success("Order status updated successfully");
      toggleStatusModal();
      fetchOrderDetail();
    } catch (error) {
      console.error("Update status failed:", error);
      toast.error("Failed to update order status");
    } finally {
      setUpdatingStatus(false);
    }
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => {
        if (row.isSeparator) return "";
        if (row.isSummary) return "";
        return index + 1;
      },
      sortable: false,
      width: "75px",
      style: (row) =>
        row.isSummary ? { fontWeight: row.isTotal ? "bold" : "600" } : {},
    },
    {
      name: "Product Name",
      selector: (row) => {
        if (row.isSeparator) return "";
        if (row.isSummary) return "";
        return (
          <Link to={`/item/detail/${row.productId || ""}`}>
            {row.productName}
          </Link>
        );
      },
      sortable: false,
      wrap: true,
      width: "350px",
    },
    {
      name: "Category Name",
      selector: (row) => {
        if (row.isSeparator) return "";
        if (row.isSummary) return "";
        return row.categoryName;
      },
      sortable: false,
      wrap: true,
      width: "180px",
    },
    {
      name: "Notes",
      selector: (row) => {
        if (row.isSeparator || row.isSummary) return "";
        return row.remarks || "-";
      },
      sortable: false,
      wrap: true,
      omit: false,
    },
    {
      name: "Quantity",
      selector: (row) => {
        if (row.isSeparator || row.isSummary) return "";
        return row.quantity;
      },
      right: true,
      sortable: false,
      width: "90px",
      compact: true,
    },
    {
      name: "Price",
      selector: (row) => {
        if (row.isSeparator) return "";
        if (row.isSummary) {
          return (
            <span style={{ fontWeight: row.isTotal ? "bold" : "600" }}>
              {row.label}
            </span>
          );
        }
        return <NumberWithCommas number={row.productPrice} />;
      },
      right: true,
      sortable: false,
      width: "120px",
      compact: true,
    },
    {
      name: "Total",
      selector: (row) => {
        if (row.isSeparator) return "";
        if (row.isSummary) {
          const displayValue = row.isDiscount ? Math.abs(row.value) : row.value;
          return (
            <span
              style={{
                fontWeight: row.isTotal ? "bold" : "600",
                fontSize: row.isTotal ? "1.05rem" : "0.9rem",
                color: row.isDiscount ? "#dc3545" : "inherit",
              }}
            >
              {row.isDiscount && "- "}
              <NumberWithCommas number={displayValue} />
            </span>
          );
        }
        return <NumberWithCommas number={row.productPrice * row.quantity} />;
      },
      sortable: false,
      right: true,
      width: "120px",
      style: (row) =>
        row.isSummary ? { fontWeight: row.isTotal ? "bold" : "600" } : {},
    },
  ];

  const filteredData =
    orderDetail?.orderDetails?.filter((item) =>
      item.productName?.toLowerCase().includes(filterText.toLowerCase())
    ) || [];

  const tableDataWithSummary =
    filteredData.length > 0
      ? [
          ...filteredData,
          { isSeparator: true },
          {
            isSummary: true,
            label: "Sub Total",
            value: orderDetail?.totalAmount || 0,
          },
          ...(orderDetail?.taxAmount > 0
            ? [
                {
                  isSummary: true,
                  label: "Tax Amount",
                  value: orderDetail.taxAmount,
                },
              ]
            : []),
          ...(orderDetail?.discountAmount > 0
            ? [
                {
                  isSummary: true,
                  label: "Discount",
                  value: -orderDetail.discountAmount,
                  isDiscount: true,
                },
              ]
            : []),
          {
            isSummary: true,
            isTotal: true,
            label: "Total Amount",
            value: orderDetail?.grandTotal || 0,
          },
        ]
      : filteredData;

  const handleFilter = (e) => setFilterText(e.target.value);

  const breadcrumbItems = [
    { title: "Back To List", onClick: () => navigate(-1) },
  ];

  return (
    <>
      {orderDetail ? (
        <Container fluid>
          <div className="page-content">
            <BreadCrumb
              title="Orders"
              pageTitle="Order Details"
              breadcrumbItems={breadcrumbItems}
            />

            <div className=" " ref={printRef}>
              <div className="invoice-section mb-3 px-4 py-3 bg-white rounded shadow-sm border">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
                  <div>
                    <h5 className="fw-bold mb-0">
                      Invoice #{orderDetail.invoiceNumber}
                    </h5>
                    <small className="text-muted">
                      Order ID: {orderDetail.orderRefrenceId}
                    </small>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <StatusBadge
                      status={orderDetail.paymentStatus}
                      type="payment"
                      pill={true}
                    />
                    {orderDetail.userId && orderDetail?.paymentStatus?.toLowerCase() !== "paid" &&
                      orderDetail?.orderStatus?.toLowerCase() !==
                        "cancelled" && (
                        <Button
                          size="sm"
                          color="success"
                          className="p-1 px-3 rounded-pill"
                          style={{ fontWeight: "600", lineHeight: 1 }}
                          onClick={handleDirectPayment}
                        >
                          Pay
                        </Button>
                      )}
                  </div>
                </div>

                <Row className="g-3 align-items-center">
                  <Col xl={2} lg={3} md={4} sm={6}>
                    <div className="info-item">
                      <small
                        className="text-muted text-uppercase d-block mb-1"
                        style={{ fontSize: "0.7rem", letterSpacing: "0.5px" }}
                      >
                        <i className="bx bx-table me-1"></i>Table
                      </small>
                      <div className="fw-semibold">
                        {orderDetail.userId
                          ? "Public Ordering"
                          : orderDetail.tableName}
                      </div>
                    </div>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <div className="info-item">
                      <small
                        className="text-muted text-uppercase d-block mb-1"
                        style={{ fontSize: "0.7rem", letterSpacing: "0.5px" }}
                      >
                        <i className="bx bx-calendar me-1"></i>Date (BS)
                      </small>
                      <div className="fw-semibold">
                        {orderDetail.orderDate_Nep}
                      </div>
                    </div>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <div className="info-item">
                      <small
                        className="text-muted text-uppercase d-block mb-1"
                        style={{ fontSize: "0.7rem", letterSpacing: "0.5px" }}
                      >
                        <i className="bx bx-time me-1"></i>Date & Time
                      </small>
                      <div
                        className="fw-semibold"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {orderDetail.orderDate}
                      </div>
                    </div>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <div className="info-item">
                      <small
                        className="text-muted text-uppercase d-block mb-1"
                        style={{ fontSize: "0.7rem", letterSpacing: "0.5px" }}
                      >
                        <i className="bx bx-check-circle me-1"></i>Status
                      </small>
                      <div className="d-flex align-items-center gap-2">
                        <StatusBadge
                          status={orderDetail.orderStatus}
                          type="order"
                          pill={true}
                        />

                        {orderDetail.userId &&
                          orderDetail.orderStatus?.toLowerCase() !==
                            "cancelled" && (
                            <Button
                              size="sm"
                              color="link"
                              className="p-0"
                              onClick={toggleStatusModal}
                              style={{ lineHeight: 1 }}
                            >
                              <i className="bx bx-edit fs-6 text-primary"></i>
                            </Button>
                          )}
                      </div>
                    </div>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <div className="info-item">
                      <small
                        className="text-muted text-uppercase d-block mb-1"
                        style={{ fontSize: "0.7rem", letterSpacing: "0.5px" }}
                      >
                        <i className="bx bx-credit-card me-1"></i>Payment
                      </small>
                      <div className="d-flex flex-wrap gap-1">
                        {orderDetail?.payments?.length > 0 ? (
                          orderDetail.payments.map((payment, idx) => (
                            <StatusBadge
                              key={idx}
                              status={payment.paymentType}
                              variant="secondary"
                              pill
                            />
                          ))
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <div className="info-item">
                      <small
                        className="text-muted text-uppercase d-block mb-1"
                        style={{ fontSize: "0.7rem", letterSpacing: "0.5px" }}
                      >
                        Total Amount
                      </small>
                      <div className="fw-bold text-primary fs-5">
                        NPR <NumberWithCommas number={orderDetail.grandTotal} />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div
                className="p-3 p-lg-4 mt-1"
                style={{
                  background: "#ffffff",
                  borderRadius: "0.5rem",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  border: "1px solid #eee",
                }}
              >
                <Row className="justify-content-between align-content-center align-items-center ">
                  <Col md={6} className="align-items-center">
                    <h5 className="mb-1 fw-bold text-dark ">Orders List</h5>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex justify-content-end align-content-center align-items-center ">
                      <Row className="gx-1">
                        <Col>
                          <InputGroup>
                            <Input
                              type="text"
                              placeholder="Search..."
                              value={filterText}
                              onChange={handleFilter}
                            />
                            <InputGroupText style={{ cursor: "pointer" }}>
                              <i className="bx bx-search"></i>
                            </InputGroupText>
                          </InputGroup>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                <hr style={{ borderColor: "#000000ff", marginTop: "0rem" }} />
                <div className="mt-3">
                  <DataTable
                    responsive
                    striped
                    pagination={false}
                    fixedHeader
                    highlightOnHover
                    pointerOnHover
                    persistTableHead
                    progressPending={loading}
                    customStyles={customStyles}
                    paginationResetDefaultPage={resetPaginationToggle}
                    progressComponent={
                      <div className="my-2 text-center">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                          ariaLabel="triangle-loading"
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                    columns={columns}
                    data={tableDataWithSummary}
                    conditionalRowStyles={[
                      {
                        when: (row) => row.isSeparator,
                        style: {
                          minHeight: "0.1px",
                          "&:hover": {
                            cursor: "default",
                          },
                        },
                      },
                      {
                        when: (row) => row.isSummary && !row.isTotal,
                        style: {},
                      },
                      {
                        when: (row) => row.isTotal,
                        style: {
                          fontWeight: "bold",
                          borderTop: "1px solid #495057",
                        },
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </Container>
      ) : (
        <div className="text-center my-5">Loading...</div>
      )}

      {/* Status Modal */}
      <Modal isOpen={statusModalOpen} toggle={toggleStatusModal} centered>
        <ModalHeader toggle={toggleStatusModal}>
          Update Order Status
        </ModalHeader>

        <ModalBody>
          <Row className="g-3">
            {orderStatusEnum.map((s) => {
              const isActive = orderDetail?.orderStatus === s.name;

              const colorMap = {
                1: "primary",
                2: "success",
                3: "danger",
                4: "warning",
              };

              return (
                <Col md={6} key={s.value}>
                  <Card
                    onClick={() => !isActive && updateOrderStatus(s.value)}
                    className={`p-3 text-center border ${
                      isActive ? "border-2 border-success" : ""
                    }`}
                    style={{
                      cursor:
                        isActive || updatingStatus ? "not-allowed" : "pointer",
                      opacity: updatingStatus ? 0.6 : 1,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <i
                      className={`bx bx-check-circle fs-1 text-${
                        colorMap[s.value]
                      }`}
                    ></i>

                    <h6 className="mt-2 mb-1">{s.name}</h6>

                    {isActive ? (
                      <Badge color="success">Current</Badge>
                    ) : (
                      <Badge color={colorMap[s.value]}>Set Status</Badge>
                    )}
                  </Card>
                </Col>
              );
            })}
          </Row>

          {updatingStatus && (
            <div className="text-center mt-4">
              <Spinner size="sm" /> Updating order status...
            </div>
          )}
        </ModalBody>
      </Modal>

      {/* Payment Modal */}
      <ConfirmPayment
        isOpen={paymentModalOpen}
        toggle={togglePaymentModal}
        handleCheckout={handleCheckout}
        billData={transformOrderDataForPayment()}
        selectedPayment={null}
        setSelectedPayments={setSelectedPayments}
        selectedPayments={selectedPayments}
        handleApplyPromo={() => {}}
        setPromoCode={setPromoCode}
        promoCode={promoCode}
        calculateTotals={calculateTotals}
        handlePercentChange={(e) => setDiscountPercent(e.target.value)}
        Credit={false}
        discountPercent={discountPercent}
        setDiscountPercent={setDiscountPercent}
        discountAmount={discountAmount}
        setDiscountAmount={setDiscountAmount}
        promoSuccess={promoSuccess}
        setPromoSuccess={setPromoSuccess}
        promoError={promoError}
        setPromoError={setPromoError}
        selectedTable={{
          id: orderDetail?.orderRefrenceId,
          tableName: orderDetail?.tableName,
        }}
        setLastUpdated={() => {}}
        user={null}
        selectedCustomer={null}
        orgInfo={null}
        toggleListModal={() => {}}
        setCreditData={setCreditData}
        creditData={creditData}
        paymentAmounts={paymentAmounts}
        setPaymentAmounts={setPaymentAmounts}
        handleAmountChange={(e) => setDiscountAmount(e.target.value)}
        placedItems={orderDetail?.orderDetails || []}
        responseData={null}
        isTakeawayPaymentPending={false}
        setIsTakeawayPaymentPending={() => {}}
        handleUnmergeTable={() => {}}
        selectedAttributes={[]}
        itemPrice={0}
      />

      {isInvoiceModalOpen && invoiceData && (
        <InvoiceBillModal
          isOpen={isInvoiceModalOpen}
          toggle={() => setIsInvoiceModalOpen(false)}
          orgInfo={orgInfo}
          user={user}
          selectedTable={{
            id: orderDetail?.orderRefrenceId,
            tableName: orderDetail?.tableName,
          }}
          orderId={orderDetail?.id}
          billData={invoiceData.billInfo}
          calculateTotals={calculateTotals}
          responseData={invoiceData.responseData}
          selectedCustomer={customerInfo} // or null if public
          selectedPayments={selectedPayments}
          userInfo={user}
          placedItems={orderDetail?.orderDetails || []}
        />
      )}

      <OrderDetailModal
        isOpen={modalOpen}
        toggle={toggleModal}
        orderData={selectedData}
      />
    </>
  );
};

export default OrderDetail;
